export const logger = {
  log: (bracket, text, color) => {
    if (typeof window == "undefined" || process.env.NEXT_PUBLIC_API_LOG_CLIENT)
      console.log(color + "[" + bracket + "] \x1B[0m " + text);
  },
  error: (bracket, text) => {
    logger.log(bracket, text, "\x1B[31m");
  },
  succes: (bracket, text) => {
    logger.log(bracket, text, "\x1B[92m");
  },
};
